import React from "react";

import { useTranslation } from "react-i18next";

import {
  StateButton,
  StateContainer,
  StateContainerColumn,
  StateHeading,
  StateParagraph,
} from "./style";

const CosmosNotSetup = () => {
  const { t } = useTranslation();

  return (
    <StateContainer>
      <StateContainerColumn>
        <StateContainerColumn style={{ gap: "16px" }}>
          <StateHeading style={{ fontSize: "18px", color: "#171717" }}>
            {t("module-requires-a-field")}
          </StateHeading>
          <StateParagraph style={{ fontSize: "14px" }}>
            {t("select-appropriate-field")}
          </StateParagraph>
        </StateContainerColumn>
        <StateButton
          onClick={() =>
            window.open(
              `${window.AP._hostOrigin}/wiki/plugins/servlet/ac/com.caelor.confluence.cloud.cosmos/caelor-cosmos-portal?ac.cosmosPage=settings-people_base-widgets`,
              "_blank"
            )
          }
        >
          {t("configure-cosmos")}
        </StateButton>
      </StateContainerColumn>
    </StateContainer>
  );
};

export default CosmosNotSetup;
